import lottie from "lottie-web";

let animationPath;
let resizeTimeout;
let loadedAnimation = null;

const isFullMobile = () => window.innerWidth < 840;
const getAnimationPath = (elementId) => {
  const animationContainer = document.getElementById(elementId);

  return animationContainer
    ? isFullMobile()
      ? animationContainer.getAttribute('data-mobile-src')
      : animationContainer.getAttribute('data-src')
    : null;
};

const heroPlatformAnimation = (elementId = 'platform-top-animation') => {
  const newAnimationPath = getAnimationPath(elementId);
  
  if (!newAnimationPath) return;

  animationPath = newAnimationPath;

  const animationContainer = document.getElementById(elementId);
  if (loadedAnimation) {
    loadedAnimation.destroy();
  }

  loadedAnimation = lottie.loadAnimation({
    container: animationContainer,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: animationPath,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid meet'
    }
  });
};

const heroPlatformAnimationResizeInit = () => {
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimeout);
    resizeTimeout = setTimeout(() => {
      heroPlatformAnimation();
    }, 250);
  });
}

export { heroPlatformAnimation, heroPlatformAnimationResizeInit, loadedAnimation };
